export type BrowserName = 'chrome' | 'safari' | 'firefox' | 'edge' | 'other';

export const detectBrowser = (
  userAgent: string = typeof navigator !== 'undefined' ? navigator.userAgent : ''
): BrowserName => {
  const ua = userAgent.toLowerCase();

  if (ua.includes('edg/') || ua.includes('edga/') || ua.includes('edgios/')) {
    return 'edge';
  }
  if (ua.includes('firefox') || ua.includes('fxios')) {
    return 'firefox';
  }
  if (ua.includes('chrome') || ua.includes('crios') || ua.includes('chromium')) {
    return 'chrome';
  }
  if (ua.includes('safari')) {
    return 'safari';
  }
  return 'other';
};
